/* eslint-disable no-lone-blocks */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Stories from "react-insta-stories";
import ReactGA from "react-ga4";

import "./style.css";
import { bottomBarActions } from "../../store/bottomBarSlice";
import { storieAction } from "../../store/storieSlice";
import { chefActions } from "../../store/chefSlice";
import mixpanel from "mixpanel-browser";
import BackBtnSvg from "../../assets/ReactSvg/BackBtnSvg";
import { menuActions } from "../../store/menuSlice";
import classNames from "classnames";
import TimerSvgIcon from "../../assets/ReactSvg/TimerSvgIcon";
import { ToastContainer } from "react-toastify";
import {
  getDisplayChefTimeLabel,
  getTodayDateValue,
} from "../../utils/timeHelper";
import AddCartIconSvg from "../../assets/ReactSvg/AddCartIconSvg";
import { removeDish, updatePortion } from "../../store/cartActions";
import moment from "moment";
import { calculateCurrentPrice, combineTheDate } from "../../utils/helper";
import { S3_MENU_FOLDER } from "../../store/constants";
import StarFourIconSvg from "../../assets/ReactSvg/StarFourIconSvg";
// import clevertap from "clevertap-web-sdk";

const capitalize = (str) =>
    str ? str[0].toUpperCase() + str.slice(1).toLowerCase() : "";

const SingleStoriePage = () => {
  useEffect(() => {
    // ReactGA.send({ hitType: "pageview", page: "/stories" });
    ReactGA.event({
      category: "tab",
      action: "stories",
    });
    window.scrollTo(0, 1);
  }, []);
  const currentPriceRef = useRef();
  const [currentPrice, setCurrentPrice] = useState(0);
  const user = useSelector(({ auth }) => auth.user);
  const childernData = useSelector((store) => store.storie.storieData || []);
  const from = useSelector((store) => store.storie.from || []);
  const chefIdState = useSelector((store) => store.chef.chefId);
  const chefList = useSelector((state) => state.chef.chefList);
  const dishes = useSelector((state) => state.bottomBar.dishes);
  const chef = useSelector((state) => state.bottomBar.chef);
  const cart = useSelector((state) => state.bottomBar.cart);
  const dishInfo = childernData[0]?.dish || {};
  const currentChefDetails = chefList.find((c) => c._id === chefIdState) || {};
  const loggedIn = !!user.phonenumber;
  const chefTimeData = useSelector((state) => state.chef.chefTime);
  
  const { cartData, scheduleTime, isScheduleNow } = useSelector(
    ({ cart }) => cart
  );
  const menuCartDataInfo = cartData.find(
    (c) => (c.dishId || c._id) === dishInfo._id
  );
  const currentChefsTime = chefTimeData[chefIdState];

  const isDishAddedToCart = cartData
    .map((cart) => cart._id)
    ?.includes(dishInfo._id);
  const currentDishCount =
    cartData?.find((order) => order._id === dishInfo._id)?.portion || 0;
    const scheduleDateTime = combineTheDate(
      scheduleTime?.date,
      scheduleTime?.time
    );

    const discountType = loggedIn
    ? user.maxDishes > user.totalDishesBooked
      ? "deepDiscount"
      : "normal"
    : "deepDiscount";

  const dispatch = useDispatch();
  const onStoryBackClick = () => {
    switch (from) {
      case "dishes":
        dispatch(bottomBarActions.loadTab({ tabName: "dishes" }));
        mixpanel.track("story-back-to-dishes");
        // clevertap.event.push("story-back-to-dishes");
        return;
      case "cart":
        dispatch(bottomBarActions.loadTab({ tabName: "cart" }));
        mixpanel.track("story-back-to-cart");
        // clevertap.event.push("story-back-to-cart");
        return;
      case "chef":
        dispatch(bottomBarActions.loadTab({ tabName: "chef" }));
        mixpanel.track("story-back-to-chef");
        // clevertap.event.push("story-back-to-chef");
        return;
      case "menu":
        // dispatch(bottomBarActions.loadTab({ tabName: "menu" }));
        // mixpanel.track("story-back-to-menu");
        dispatch(bottomBarActions.loadTab({ tabName: "chefListScreen" }));
        mixpanel.track("story-back-to-menu");
        // clevertap.event.push("story-back-to-menu");
        return;
      case "dishBook":
        dispatch(bottomBarActions.loadTab({ tabName: "dishBook" }));
        mixpanel.track("story-back-to-dishBook");
        // clevertap.event.push("story-back-to-dishBook");
        return;
      case "orderSummary":
        dispatch(bottomBarActions.loadTab({ tabName: "orderSummary" }));
        mixpanel.track("story-back-to-orderSummary");
        // clevertap.event.push("story-back-to-orderSummary");
        return;
      default:
        dispatch(bottomBarActions.loadTab({ tabName: "chef" }));
        mixpanel.track("story-back-to-chef");
        // clevertap.event.push("story-back-to-chef");
        break;
    }
  };

  useEffect(() => {
    const isScheduleOrder =
      !isScheduleNow && moment(scheduleDateTime).isValid();
    const currentPriceValue = calculateCurrentPrice(
      dishInfo,
      currentChefsTime,
      currentChefDetails,
      isScheduleOrder,
      discountType,
      dishInfo?.dishSpecialType
    );
    if (!!currentPriceRef?.current) return;
    if (currentPriceValue === currentPriceRef?.current) return;
    setCurrentPrice(currentPriceValue);
    currentPriceRef.current = currentPriceValue;
  }, [
    isScheduleNow,
    scheduleDateTime,
    dishInfo,
    currentChefsTime,
    currentChefDetails,
    user.maxDishes,
    user.totalDishesBooked,
  ]);

  const addToCard = () => {
    dispatch(menuActions.setIsMenuClicked(true));
    dispatch(bottomBarActions.loadTab({ tabName: "chefListScreen" }));
    if (chefIdState) {
      dispatch(chefActions.onMenuClick(chefIdState));
    }
    mixpanel.track("go-to-menu-clicked");
    // clevertap.event.push("go-to-menu-clicked");
  };

  const onRemoveDish = async (dishId) => {
    const payload = {
      userId: user.userid,
      dishId: dishId,
      isActive: false,
      maxDishes: user.maxDishes,
      dealPrice: menuCartDataInfo.dealPrice,
      isFromCart: false,
    };
    let totalDiscountedDishesAdded = 0;
    let isDiscountAllowed =
      user.totalDishesBooked + totalDiscountedDishesAdded < user.maxDishes;
    let isAddedOnDiscount =
      isDiscountAllowed && user.maxDishes !== 0 ? true : false;

    if (currentDishCount > 1) {
      const payload = {
        cartPayload: {
          userId: user.userid,
          dishId: dishId,
          dealPrice: currentPrice,
          isAddedOnDiscount: isAddedOnDiscount,
          price: dishInfo.price,
          portion: currentDishCount - 1,
        },
        dish: { ...dishInfo, portion: currentDishCount - 1 },
        maxDishes: user.maxDishes,
        isFromCart: false,
        actionType: "REMOVE",
      };
      const cartDishInfo = cartData?.find((cart) => cart._id === dishId);
      payload.cartId = cartDishInfo.cartId;
      payload.cartPayload.dealPrice = menuCartDataInfo.dealPrice;
      dispatch(updatePortion(payload));
    } else {
      payload.dealPrice = menuCartDataInfo.dealPrice;
      dispatch(removeDish(payload));
    }
    mixpanel.track("dish-removed");
    // clevertap.event.push("dish-removed");
  };

  const todayChefSchedule = getTodayDateValue(
    currentChefDetails?.schedules || []
  );

  const textOutput = getDisplayChefTimeLabel(todayChefSchedule);
  const labelsArrayList = dishInfo.stories.filter((a) => a.header);
  
  const stories = dishInfo.stories?.map(
    ({
      img,
      description,
      price,
      dish,
      discountMessage = "",
      header,
      caption,
      dealPrice,
    }) => ({
      url: S3_MENU_FOLDER + img,
      duration: 3000,
      content: () => {
        return (
          <div className="image-container_wrapper">
            <div
              style={{ position: "absolute", top: "0px", height: "100%" }}
              className="image-container"
            >
              <>
                <img
                  src={S3_MENU_FOLDER + img}
                  className={classNames("story-image-container", {
                    // "story-image-container-zoom": showChefInfo,
                    // "story-image-container-zoom-animation": dishNameHighlight,
                  })}
                  loading="lazy"
                  style={{ height: "100vh", objectFit: "cover" }}
                />
              </>
            </div>
            <div className={`exploreChefScreen show`}>
              <div className="swiper_Top explore_swiper_Top"></div>
              <div
                className={classNames("swipper_bottom explore_swipper_bottom", {
                  // explore_chefinfo_swipper_bottom: showChefInfo || dishNameHighlight,
                  // show: dishNameHighlight && isVisible,
                })}
              >
                <div
                  // style={!!labelDesc?.demoLabel ? { height: 140 } : {}}
                  className="explore-swipper_bottom"
                >
                  <div
                    className={classNames("exploreDishNameTitleWrapper", {
                      // hideOpacityText:
                      //   DEMO_EXPLORE && labelDesc?.highlightedText !== "DISH_NAME",
                    })}
                  >
                    <span
                      className={classNames("exploreDishNameTitle Satoshi", {
                        // exploreDishNameTitleBold:
                        //   DEMO_EXPLORE && labelDesc?.highlightedText === "DISH_NAME",
                      })}
                    >
                      {dishInfo.name}
                    </span>
                  </div>
                  <div
                    className={classNames("chef-info-name-wrapper", {
                      // hideOpacityText:
                      //   DEMO_EXPLORE && labelDesc?.highlightedText !== "CHEF_CARD",
                    })}
                  >
                    <div
                      // onClick={onChefNameClick}
                      className="swiper_Title_img explore_swiper_Title_img"
                    >
                      <img src={S3_MENU_FOLDER +  img} className="storyImg" />
                    </div>
                    <div>
                      <p
                        // onClick={onChefNameClick}
                        className={classNames("explore-chef-label Satoshi", {
                          // "explore-text-bold": CHEF_CARD,
                        })}
                      >
                        Chef {dishInfo.chefName}
                      </p>
                      <div className="chef-time-wrapper">
                        <TimerSvgIcon />
                        <span
                          className={classNames("explore-chef-timing-label", {
                            // "explore-text-bold": CHEF_CARD,
                          })}
                        >
                          {textOutput}
                        </span>
                      </div>
                    </div>
                    <button
                      // onClick={handleMenuClick}
                      className={classNames("explore-story-menu-button", {
                        // "explore-text-bold": CHEF_CARD,
                      })}
                    >
                      Menu
                    </button>
                  </div>
                  <div className="ingrident-list-wrapper">
                    {!!header && (
                      <div className="ingrident-list-header-label">
                        {labelsArrayList.map((l, index) => {
                          return (
                            <div key={index}>
                              <span
                                className={classNames({
                                  "ingrident-list-header-label-active Satoshi":
                                    l.header === header,
                                  // "ingrident-list-header-label-active-bold":
                                  //   DISH_CAPTION && l.key === header,
                                })}
                              >
                                {capitalize(l.header)}
                              </span>
                              {index + 1 < dishInfo.stories.length && <StarFourIconSvg />}
                            </div>
                          );
                        })}
                      </div>
                    )}
                    <div
                      className={classNames({
                        // "label-desc demo Satoshi": labelDesc?.demoDesc,
                        // "label-desc Satoshi": !labelDesc?.demoDesc,
                        // hideOpacityText:
                        //   DEMO_EXPLORE &&
                        //   labelDesc?.highlightedText !== "DISH_CAPTION",
                        // "explore-text-bold":
                        //   (DEMO_EXPLORE &&
                        //   labelDesc?.highlightedText === "DISH_CAPTION") || joinWaitlist,
                      })}
                    >
                      {caption || dishInfo.description}
                    </div>
                  </div>
                  {(!!dishInfo.dealPrice || dishInfo.price) && (
                    <div className="explore_swipper_bottom_first">
                      <div
                      //  className={classNames({ hideOpacityText: DEMO_EXPLORE })}
                      >
                        <div className="items_value">
                          <div className="plus_taxes">
                            <h5 className="explore-deal-price-wrapper">
                              <span className="explore-deal-price Satoshi">
                                {`₹${dishInfo.dealPrice > 0 ? dishInfo.dealPrice : dishInfo.price}`}
                              </span>
                              {dishInfo.dealPrice > 0 && (
                                <span className="price-strike explore-price-strike Satoshi">
                                  {`₹${dishInfo.price}`}
                                </span>
                              )}
                            </h5>
                          </div>
                        </div>
                      </div>
                      {/* <div
                        className={classNames("explore-addcart_btn", {
                          // hideOpacityText: DEMO_EXPLORE,
                        })}
                      >
                        {!isDishAddedToCart ? (
                          <button
                            className="Satoshi"
                            onClick={addToCard}
                          >
                            <AddCartIconSvg />
                            <span className="explore-addcart_btn_text">
                            Add to cart
                            </span>
                          </button>
                        ) : (
                          <button style={{ padding: "0px 8px 0px 8px" }}>
                            <span onClick={() => onRemoveDish(dishInfo._id)}>
                              -
                            </span>
                            <span
                              style={{ fontSize: "18px", lineHeight: "22px" }}
                            >
                              {currentDishCount}
                            </span>
                            <span onClick={() => addToCard(dishInfo._id)}>
                              +
                            </span>
                          </button>
                        )}
                      </div> */}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <ToastContainer limit={1} />
          </div>
        );
      },
    })
  );

  const onAllStoriesEnd = () => {
    switch (from) {
      case "dishes":
        dispatch(bottomBarActions.loadTab({ tabName: "dishes" }));
        return;
      case "cart":
        dispatch(bottomBarActions.loadTab({ tabName: "cart" }));
        return;
      case "chef":
        dispatch(bottomBarActions.loadTab({ tabName: "chef" }));
        return;
      case "menu":
        dispatch(bottomBarActions.loadTab({ tabName: "chefListScreen" }));
        // dispatch(bottomBarActions.loadTab({ tabName: "menu" }));
        return;
      case "dishBook":
        dispatch(bottomBarActions.loadTab({ tabName: "dishBook" }));
        return;
      case "orderSummary":
        dispatch(bottomBarActions.loadTab({ tabName: "orderSummary" }));
        return;
      default:
        dispatch(bottomBarActions.loadTab({ tabName: "chef" }));
        break;
    }
    dispatch(storieAction.setStorieFalse());
  };
console.log("stories", stories, dishInfo);
  return (
    <div className="stories_wrapper single_stories_wrapper">
      <Stories onAllStoriesEnd={onAllStoriesEnd} stories={stories} />
    </div>
  );
};

export default SingleStoriePage;
